import type * as Types from '../../../types';

import client from "apollo/client";
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetPendingUserRequestsQueryVariables = Types.Exact<{
  skip?: Types.InputMaybe<Types.Scalars['Int']>;
  take?: Types.InputMaybe<Types.Scalars['Int']>;
  where?: Types.InputMaybe<Types.UserFilterInput>;
  order?: Types.InputMaybe<Array<Types.UserSortInput> | Types.UserSortInput>;
}>;


export type GetPendingUserRequestsQuery = { __typename?: 'Query', users?: { __typename?: 'UserCollectionSegment', totalCount: number, items?: Array<{ __typename?: 'User', id: string, tenantId: string, email: string, displayName: string, createdAt: string, tenant: { __typename?: 'Tenant', tenantRole: Types.TenantRole, tenantName: string, phoneNumber: string, postalCode: string, city: string, country: string, streetAndNumber: string } }> | null } | null };


        export type ExecGetPendingUserRequestsOptions = Omit<
        Apollo.QueryOptions<
        GetPendingUserRequestsQueryVariables, GetPendingUserRequestsQuery
        >,
        "query"
      >;
    export const execGetPendingUserRequestsQuery = (options: ExecGetPendingUserRequestsOptions) =>
    client.query< GetPendingUserRequestsQuery, GetPendingUserRequestsQueryVariables>({
      ...options,
      query: GetPendingUserRequestsDocument,
    });
    

export const GetPendingUserRequestsDocument = gql`
    query getPendingUserRequests($skip: Int, $take: Int, $where: UserFilterInput, $order: [UserSortInput!]) {
  users(where: $where, skip: $skip, take: $take, order: $order) {
    totalCount
    items {
      id
      tenantId
      tenant {
        tenantRole
        tenantName
        phoneNumber
        postalCode
        city
        country
        streetAndNumber
      }
      email
      displayName
      createdAt
    }
  }
}
    `;

/**
 * __useGetPendingUserRequestsQuery__
 *
 * To run a query within a React component, call `useGetPendingUserRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPendingUserRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPendingUserRequestsQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      where: // value for 'where'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useGetPendingUserRequestsQuery(baseOptions?: Apollo.QueryHookOptions<GetPendingUserRequestsQuery, GetPendingUserRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPendingUserRequestsQuery, GetPendingUserRequestsQueryVariables>(GetPendingUserRequestsDocument, options);
      }
export function useGetPendingUserRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPendingUserRequestsQuery, GetPendingUserRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPendingUserRequestsQuery, GetPendingUserRequestsQueryVariables>(GetPendingUserRequestsDocument, options);
        }
export type GetPendingUserRequestsQueryHookResult = ReturnType<typeof useGetPendingUserRequestsQuery>;
export type GetPendingUserRequestsLazyQueryHookResult = ReturnType<typeof useGetPendingUserRequestsLazyQuery>;
export type GetPendingUserRequestsQueryResult = Apollo.QueryResult<GetPendingUserRequestsQuery, GetPendingUserRequestsQueryVariables>;
export type PartialResultType<T> = Types.PartialResultType<T>;
          export type ResultType<T> = Types.ResultType<T>;
          export type PaginatedResultType<T> = Types.PaginatedResultType<T>;
          export type NonMaybe<T> = Types.NonMaybe<T>;
          export type Maybe<T> = Types.Maybe<T>;